/**
 * Notification Registry
 *
 * @module NotificationRegistry
 * @see docs/notifications.md
 *
 * Type-safe registry for notification renderers. Each notification type
 * (e.g. "workflow-run-complete") can register a custom React component
 * to render its content in the notification panel.
 */

import type { ComponentType } from 'react';

export interface NotificationData {
  id: string;
  orgId: string;
  userId: string | null;
  type: string;
  title: string;
  data: Record<string, unknown>;
  read: boolean;
  createdAt: string;
}

export interface NotificationRendererProps {
  notification: NotificationData;
}

const registry = new Map<string, ComponentType<NotificationRendererProps>>();

export function registerNotificationRenderer(
  type: string,
  component: ComponentType<NotificationRendererProps>
) {
  registry.set(type, component);
}

export function getNotificationRenderer(
  type: string
): ComponentType<NotificationRendererProps> | undefined {
  return registry.get(type);
}
